import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import CarCarousel from './components/CarCarousel';
import MapLocation from './components/MapLocation';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen bg-transparent text-white overflow-x-hidden">
      {/* Fixed Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-black/90 backdrop-blur-xl shadow-2xl' : 'bg-transparent'
        }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <img
              src="https://static.readdy.ai/image/4e6d233a4d13eb9885bc14dac5e47a67/6fd14fe2a55165d4c4c555bc2c0cbfef.png"
              alt="Urban Drive Logo"
              className="h-12 sm:h-14 w-auto"
            />
            <button
              className="w-10 h-10 flex items-center justify-center text-white hover:text-[#fe7222] transition-colors"
              aria-label="Menu"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>

      <Hero />
      <CarCarousel />
      <MapLocation />
      <Footer />
    </div>
  );
}
